module.exports = __webpack_public_path__ + "static/pic-profile-member-1-ee8963caf493aff26ab4d38aff29f68e.png";